import React, { FC } from 'react';
import { useField } from 'formik';

import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';

type Props = Omit<CheckboxProps, 'checked' | 'onChange'> & {
  name: string;
};

const Checkbox: FC<Props> = props => {
  const [field] = useField(props.name);

  return <MuiCheckbox {...props} {...field} checked={field.value} />;
};

export default Checkbox;
